import type { FC, MouseEvent, RefObject } from 'react';

import { memo } from 'react';
import styled, { css } from 'styled-components';

import { CTA } from '~/components/shared/core/button/CTA';

type ProductGalleryShowMoreButtonProps = {
  buttonRef: RefObject<HTMLDivElement | null>;
  showAllImages: boolean;
  showMore?: string;
  showLess?: string;
  onClick: (event: MouseEvent<HTMLElement>) => void;
};

const S = {
  ButtonWrapper: styled.div`
    [data-gallery-zoom-in='true'] & {
      display: none;
    }

    ${({ theme }) => css`
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 0;
      background-color: ${theme.colors.background.base};
      width: 100%;
      height: 40px;
      cursor: default;
      z-index: 20;
    `}
  `,
  ShowMoreButton: styled(CTA)`
    ${({ theme }) => css`
      margin: -20px auto 0;
      border-radius: ${theme.borders.radius.xs};
      box-shadow: 0 4px 6px -2px ${theme.colors.effect['shadow-5']},
        0 12px 16px -4px ${theme.colors.effect['shadow-10']};
    `}
  `,
};

const ProductGalleryShowMoreButtonComponent: FC<ProductGalleryShowMoreButtonProps> = ({
  buttonRef,
  showAllImages,
  showMore,
  showLess,
  onClick,
}) => (
  <S.ButtonWrapper ref={buttonRef}>
    <S.ShowMoreButton
      data-testid={showAllImages ? 'show-less-images-button' : 'show-more-images-button'}
      variant="solid"
      colorway="light"
      size="md"
      label={showAllImages ? showLess : showMore}
      onClick={onClick}
    />
  </S.ButtonWrapper>
);

export const ProductGalleryShowMoreButton = memo(ProductGalleryShowMoreButtonComponent);
